const API = process.env.REACT_APP_BACKEND_URL;
const sent = {};

const IGNORE = [/status code 4\d\d/i, /Network Error/i, /ResizeObserver/i, /Script error/i, /aborted/i];

function report(payload) {
  const msg = (payload.message || "").slice(0, 500);
  if (!msg || IGNORE.some((rx) => rx.test(msg))) return;
  const key = msg.slice(0, 120);
  if (sent[key] && Date.now() - sent[key] < 60000) return;
  sent[key] = Date.now();
  try {
    fetch(`${API}/api/health/client-error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, message: msg }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* never break the app from the reporter */ }
}

window.addEventListener("error", (e) => {
  report({ message: e.message || String(e.error || "Unknown error"), stack: (e.error?.stack || "").slice(0, 1500), url: window.location.href });
});

window.addEventListener("unhandledrejection", (e) => {
  const r = e.reason;
  report({ message: String(r?.message || r || "Unhandled rejection"), stack: (r?.stack || "").slice(0, 1500), url: window.location.href });
});
